<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :label-width="'80px'"
      :search-btn-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :row-style="rowStyleFun"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.common.account')" prop="loginName">
            <BjInput
              v-model="queryParams.loginName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('AccountManagement.common.account')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.common.name')" prop="realName">
            <BjInput
              v-model="queryParams.realName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('AccountManagement.common.name')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.common.status')" prop="enabled">
            <BjSelectLov
              v-model="queryParams.enabled"
              :option-list="STATUS_ENABLED_TRUE"
              :placeholder="$t('AccountManagement.common.status')"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.common.Whether')" prop="locked">
            <BjSelectLov
              v-model="queryParams.locked"
              :option-list="STATUS_YES_TRUE"
              :placeholder="$t('AccountManagement.common.Whether')"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.common.from')" prop="startDateActive">
            <BjDatePicker v-model="queryParams.startDateActive" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.common.until')" prop="endDateActive">
            <BjDatePicker v-model="queryParams.endDateActive" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:seniorForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagement.common.Expired')" prop="activeFlag">
              <BjSelectLov
                v-model="queryParams.activeFlag"
                :option-list="STATUS_YES_TRUE"
                :placeholder="$t('AccountManagement.common.Expired')"
              /> </el-form-item
          ></el-col>
          <el-col :span="colSpan"><el-form-item></el-form-item></el-col>
      </template>
      <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <BjStatusTabs
            :value="auditTabsValue"
            :option-list="TAB_LIST"
            @handleTabClick="handleTabClick"
          />
        </el-col>
      </template>
      <template v-slot:tableOperation="">
        <el-col>
          <el-button
            v-permission:BusinessUserAccountAdd
            type="primary"
            class="main-btn"
            @click="toPage()"
            >{{ $t('AccountManagement.common.New') }}</el-button
          >

          <el-button
            v-permission:BusinessUserAccountCustom
            type="primary"
            class="main-btn"
            @click="addCustom"
            >{{ $t('AccountManagement.common.NewCustom') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <el-tag
                v-else-if="col.prop === 'enabled'"
                :type="scope.row.enabled ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row.enabled)) }}</el-tag
              >
              <el-tag
                v-else-if="col.prop === 'locked'"
                :type="scope.row.locked ? 'danger' : 'info'"
                >{{ $t(STATUS_YES_TRUE.bjGet(scope.row.locked)) }}</el-tag
              >
              <el-tag
                v-else-if="col.prop === 'activeFlag'"
                :type="scope.row.activeFlag ? 'danger' : 'info'"
                >{{ $t(STATUS_YES_TRUE.bjGet(scope.row.activeFlag)) }}</el-tag
              >
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                v-permission:BusinessUserAccountEdit
                type="text"
                class="edit-btn"
                @click="toPage(scope.row)"
                >{{ $t('AccountManagement.common.edit') }}</el-button
              >
              <el-dropdown v-hasDropdownChildren size="mini" @command="command($event, scope.row)">
                <span class="el-dropdown-link">
                  {{ $t('AccountManagement.common.operate') }}
                  <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-permission:BusinessUserAccountIndex_RelatedCompany
                    :command="$t('AccountManagement.common.structure')"
                    >{{ $t('AccountManagement.common.structure') }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-permission:BusinessUserAccountIndex_ChangePassword
                    :command="$t('AccountManagement.common.Change')"
                    >{{ $t('AccountManagement.common.Change') }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="!scope.row.enabled"
                    v-permission:BusinessUserAccountIndex_UseStatus
                    :command="$t('enableText')"
                    >{{ $t('enableText') }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-else
                    v-permission:BusinessUserAccountIndex_UseStatus
                    :command="$t('disableText')"
                    >{{ $t('disableText') }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="!scope.row.locked"
                    v-permission:BusinessUserAccountIndex_Locked
                    :command="$t('AccountManagement.common.lock')"
                    >{{ $t('AccountManagement.common.lock') }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-else
                    v-permission:BusinessUserAccountIndex_Locked
                    :command="$t('AccountManagement.common.deblocking')"
                    >{{ $t('AccountManagement.common.deblocking') }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-permission:BusinessUserAccountIndex_Delete
                    :command="$t('delText')"
                    class="delete-btn"
                    >{{ $t('delText') }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <el-dialog
      v-if="passDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="passDialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" status-icon :rules="rules" label-position="top" label-width="100px">
        <el-form-item :label="$t('AccountManagement.common.password')" prop="pass">
          <BjInput
            v-model="form.pass"
            :maxlength="MAX_LENGTH.DEFAULT"
            autocomplete="off"
            show-password
          />
        </el-form-item>
        <el-form-item :label="$t('AccountManagement.common.Confirm')" prop="checkPass">
          <BjInput
            v-model="form.checkPass"
            :maxlength="MAX_LENGTH.DEFAULT"
            autocomplete="off"
            show-password
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="submitForm('form')">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
    <dialog-company ref="dialogCompany" @reFresh="reFresh"></dialog-company>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { userApi } from '@/api';
import { STATUS_ENABLED_TRUE, STATUS_YES_TRUE } from '@/utils/constants';
import dialogCompany from './components/DialogCompany';
import { validatePass } from '@/utils';
export default {
  name: 'BusinessUserAccount',
  components: { dialogCompany },
  mixins: [pageMiXin],
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('AccountManagement.common.ps2')));
      } else if (value !== this.form.pass) {
        callback(new Error(this.$t('AccountManagement.common.ps3')));
      } else {
        callback();
      }
    };
    return {
      selection: false,
      queryApi: userApi.getUserList,
      // 查询参数
      queryParams: {
        loginName: null,
        realName: null,
        enabled: null,
        locked: null,
        activeFlag: null,
        startDateActive: null,
        endDateActive: null,
        customerType: 'P',
      },
      title: '',
      dialogVisible: false,
      /** 修改密码弹窗 */
      passDialogVisible: false,
      // 表单参数
      form: {
        pass: null,
        checkPass: null,
      },
      // 表单校验
      rules: {
        pass: [{ required: true, validator: validatePass, trigger: 'blur' }],
        checkPass: [{ required: true, validator: validatePass2, trigger: 'blur' }],
      },
      labelList: [
        { label: 'AccountManagement.common.account', prop: 'loginName', isCheck: true, disabled: false, width: 125 },
        { label: 'AccountManagement.common.name', prop: 'realName', isCheck: true, disabled: false, width: 125 },
        { label: 'AccountManagement.common.cusName', prop: 'cusName', isCheck: true, disabled: false, width: 160 },
        { label: 'AccountManagement.common.tenantName', prop: 'tenantName', isCheck: true, disabled: false, width: 125 },
        { label: 'AccountManagement.table.phone', prop: 'phone', isCheck: true, disabled: false, width: 125 },
        { label: 'AccountManagement.table.email', prop: 'email', isCheck: true, disabled: false, width: 230 },
        { label: 'AccountManagement.common.status', prop: 'enabled', isCheck: true, disabled: false, width: 100 },
        { label: 'AccountManagement.common.Whether', prop: 'locked', isCheck: true, disabled: false, width: 125 },
        { label: 'AccountManagement.common.Expired', prop: 'activeFlag', isCheck: true, disabled: false, width: 125 },
        { label: 'AccountManagement.common.from', prop: 'startDateActive', isCheck: true, disabled: false, width: 145 },
        { label: 'AccountManagement.common.until', prop: 'endDateActive', isCheck: true, disabled: false, width: 140 },
        { label: 'AccountManagement.table.creator', prop: 'createdName', isCheck: true, disabled: false, width: 125 },
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: 145 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129 },
      ],
      STATUS_ENABLED_TRUE,
      STATUS_YES_TRUE,
      clickUserId: null,
      auditTabsValue: 'P',
      TAB_LIST: [
        {
          label: this.$t('AccountManagement.common.account2'),
          value: 'P',
        },
        {
          label: this.$t('AccountManagement.common.customer'),
          value: 'C',
        }
      ],
    };
  },
  computed: {},

  created() {},
  methods: {
    handleTabClick(tab) {
      this.auditTabsValue = tab.name;
      switch (tab.name) {
        case 'P':
          this.queryParams.customerType = 'P';
          break;
        case 'C':
          this.queryParams.customerType = 'C';
          break;
      }
      this.reFresh();
    },
    rowStyleFun({ row, rowIndex }) {
      const styleJson = {};
      if (row.activeFlag) {
        styleJson.color = 'red';
      }
      return styleJson;
    },
    handleSelectionChange(data) {
    },
    command(TEXT, row) {
      this.clickUserId = row.id;
      if (TEXT === this.$t('AccountManagement.common.structure')) {
        this.$refs.dialogCompany.show(row.id);
        return;
      }
      if (TEXT === this.$t('AccountManagement.common.Change')) {
        this.title = this.$t('AccountManagement.common.Change');
        this.form = {
          pass: null,
          checkPass: null,
        };
        this.passDialogVisible = true;
        return;
      }
      this.$confirm(this.$t('AccountManagement.common.ps4') + ' ' + this.$t(TEXT) + ' ' + `${row.loginName}，` + this.$t('AccountManagement.common.ps5'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('okText'),
        cancelButtonText: this.$t('cancelText'),
        type: 'warning',
      })
        .then(() => {
          if (TEXT === this.$t('enableText')) {
            this.update('userNnfrozen');
          }
          if (TEXT === this.$t('disableText')) {
            this.update('userFrozen');
          }
          if (TEXT === this.$t('AccountManagement.common.lock')) {
            this.update('userLocked');
          }
          if (TEXT === this.$t('AccountManagement.common.deblocking')) {
            this.update('userUnlocked');
          }
          if (TEXT === this.$t('delText')) {
            this.deleteData(this.clickUserId);
          }
        })
        .catch(() => {});
    },
    update(name) {
      userApi[name]({ userId: this.clickUserId })
        .then(res => {
          if (!res.failed) {
            this.msgSuccess(this.$t('AccountManagement.common.ps6'));
            this.reFresh();
          }
        });
    },
    deleteData(id) {
      userApi
        .deleteUser({ userId: id })
        .then(res => {
          if (!res.failed) {
            this.msgSuccess(this.$t('AccountManagement.common.ps6'));
            this.reFresh();
          }
        });
    },
    /* 跳转页面 */
    toPage(row) {
      if (row) {
        this.$router.push({
          name: 'BusinessUserAccountEdit',
          query: { userId: row.id },
        });
      } else {
        this.$router.push({
          name: 'BusinessUserAccountAdd',
        });
      }
    },
    /** 新增客户 */
    addCustom() {
      this.$router.push({
        name: 'BusinessUserAccountCustom',
      });
    },
    /* **********************修改密码部分************************** */
    /**  */
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.adminUpdatePassword({
            password: this.form.checkPass,
            userId: this.clickUserId,
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleClose() {
      this.passDialogVisible = false;
      this.resetForm('form');
    },
    adminUpdatePassword(data) {
      userApi
        .adminUpdatePassword(data)
        .then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.handleClose();
          }
        });
    },
    handleChangeStartTime(startTime) {
      const { startDateActive, endDateActive } = this.queryParams;
      if (new Date(endDateActive) < new Date(startDateActive)) {
        this.queryParams.endDateActive = null;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
